import config from '@ers/config';
import BaseClient from './BaseClient';

class AuthApiClient extends BaseClient {
    constructor() {
        super(config.urls.apiAuthRoot);
    }
}
export default AuthApiClient;